module.exports = __webpack_public_path__ + "public/img/barcode.7fa6a9ac.svg";